<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <keep-alive v-if="isShow">
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
  </a-config-provider>
</template>

<script>
import { jqnAPI } from "@/api/jqn";
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')
import { mapMutations } from 'vuex'
export default {
  // mixins: [AppDeviceEnquire],
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      locale: zhCN,
      isShow: true,
      img: '', // 用户头像？
      userName: '',
      isLive: true,
      isCurrent: 0
    }
  },
  created () {
    // 解决页面刷新vuex消失
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
      setTimeout(() => {
        sessionStorage.removeItem('store')
      }, 0)
    }
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
    jqnAPI.globalConfig({
      ignoreError: true,
    }).then((res) => {
      if (res?.success) {
        const config = res?.data; // 替换整个对象
        this.setGlobalConfig(config)
      }
    });
  },
  methods: {
    ...mapMutations(['setGlobalConfig']),
    reload () {
      this.isShow = false
      this.$nextTick(function () {
        this.isShow = true
      })
    }
  }
}
</script>
<style lang="less">
  #app {
    height: 100%;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    color: #333;
    font-size: 14px;
    background: #f0f2f5;
  }
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 6px;
    -webkit-border-radius: 6px;
  }
  .noAuth .ant-modal-wrap {
    background: black;
  }
  .popover-wrap {
    .ant-popover-inner-content {
      padding: 0 !important;
    }
  }

.topIcon {
  display: flex;
  align-items: center;

  img {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    margin-right: 8px;
  }

  span {
    font-family: AlibabaPuHuiTiB, Helvetica, Arial, Verdana, Tahoma, sans-serif;
    font-size: 21.6px;
    color: #000000;
    letter-spacing: 0;
    font-weight: 700;
  }
}
.userImg {
  display: flex;
  align-items: center;
  position: relative;

  &:hover {
    cursor: pointer;
  }

  img {
    width: 30px;
    height: 30px;
    border-radius: 4px;
    margin-right: 8px;
  }

  span {
    font-family: PingFangSC-Medium, Helvetica, Arial, Verdana, Tahoma, sans-serif;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
  }

  .relative {
    position: relative;

    &:hover .noneName {
      display: block;
    }
  }

  .noneName {
    min-width: 100px;
    background: #FFFFFF;
    padding: 12px;
    font-family: PingFangSC-Medium, Helvetica, Arial, Verdana, Tahoma, sans-serif;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
    display: none;
    position: absolute;
    top: 24px;
    left: -10px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    z-index: 2000;
    line-height: 1.4;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    word-break: break-all;
  }

}
</style>
